
import { Component } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getOrderPage } from "@/api/api-charge-service";
import { getInterflowList } from "@/api/api-interconnection-service";
import { getOptionList, optionKey } from "@/api/api-dict";
import PiExportAll from "@/components/pi-export-all/pi-export-all.vue";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import piSelectStation from "@/components/select-station/select-station.vue";
import piSelectCity from "@/components/select-city/select-city.vue";
import piEndOrder from "./components/end-order.vue";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";

import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
import i18n from "@/config/i18n";
@Component({
  components: {
    piSelectOper,
    PiExportAll,
    piSelectCity,
    piSelectTableData,
    "pi-select-station": piSelectStation,
    "pi-end-order": piEndOrder
  }
})
export default class PiChargeOrderList extends mixins(tableMaxHeight) {
  private orderSourceList: any[] = [
    { label: i18n.t("orderList.orderSource1"), value: 1 },
    { label: i18n.t("orderList.orderSource2"), value: 2 }
  ];
  // private chargingModeList: any[] = [];
  private orderStatusList: any[] = [];

  private formInlineTimeType = 1;
  private abnormalTypeList: objAny = [];
  numbe = "";
  private formInline: objAny = {
    orderSource: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    oprPkId: "",
    merchantPkId: "",
    chargeOrderType: "",
    staPkId: "",
    pilePkId: "",
    orderStatus: "",
    startDate: "",
    endDate: "",
    gunPkId: "",
    orderNo: "",
    payEndTime: "",
    payStartTime: "",
    isDetails: false
  };

  private loading = true;
  win: objAny = window;
  private searchShow = true;
  private total = 0;
  chargeTimes: objAny = [];
  payTimes: objAny = [];

  private tableList: object[] = [];
  private tableColumns: object[] = [];
  private allTableData: object[] = [
    {
      title: i18n.t("commonTableName.insideOrderNo"),
      key: "orderNo",
      // slot: "orderNo",
      // fixed: "left",
      minWidth: 200
    },
    {
      title: i18n.t("commonTableName.chargeBeginTime"),
      key: "chargeBeginTime",
      minWidth: 160
    },
    {
      title: i18n.t("commonTableName.chargeEndTime"),
      key: "chargeEndTime",
      minWidth: 160
    },
    {
      title: i18n.t("nonCard.accountPkId"),
      key: "accountPkId",
      minWidth: 135
    },
    {
      title: i18n.t("commonTableName.cardNo"),
      key: "cardPhysicalNumber",
      minWidth: 130
    },
    {
      title: i18n.t("nonCard.email"),
      key: "email",
      minWidth: 160
    },
    {
      title: i18n.t("commonTableName.cardNameOrMemberName"),
      key: "contactName",
      minWidth: 180
    },
    {
      title: i18n.t("commonTableName.memberType"),
      key: "memberTypeDesc",
      minWidth: 110
    },
    {
      title: i18n.t("commonTableName.chargeDuration"),
      key: "chargeDuration",
      minWidth: 130
    },
    {
      title: i18n.t("commonTableName.staName"),
      key: "staName",
      minWidth: 160
    },
    {
      title: i18n.t("commonTableName.pileName"),
      key: "pileName",
      minWidth: 140
    },
    {
      title: i18n.t("commonTableName.gunName"),
      key: "gunName",
      minWidth: 120
    },
    {
      title: i18n.t("commonTableName.chargeElect"),
      key: "chargeElect",
      minWidth: 200
    },

    {
      title: i18n.t("commonTableName.orderStatus"),
      key: "orderStatusDesc",
      minWidth: 120,
      slot: "orderStatusDesc"
    },
    {
      title: i18n.t("commonTableName.userType"),
      key: "userTypeDesc",
      minWidth: 120
    },
    {
      title: i18n.t("commonTableName.startSoc"),
      key: "startSoc",
      minWidth: 100,
      slot: "startSoc"
    },
    {
      title: i18n.t("commonTableName.endSoc"),
      key: "endSoc",
      minWidth: 100,
      slot: "endSoc"
    },

    {
      title: i18n.t("commonTableName.orderSource"),
      key: "orderSourceDesc",
      minWidth: 120,
      slot: "orderSourceDesc"
    },
    {
      title: i18n.t("commonTableName.abnormalType"),
      key: "abnormalType",
      slot: "abnormalType",
      minWidth: 80
    },
    {
      title: i18n.t("commonTableName.stopReason"),
      key: "stopReasonDesc",
      minWidth: 140
    },
    {
      title: i18n.t("operation"),
      slot: "action",
      width: 250,
      align: "center"
    }
  ];

  async getAllInterflow(): Promise<void> {
    const ret = await getInterflowList({
      globalPageIndex: 1,
      globalPageSize: 100
      // oprPkId: this.sys.operInfo.oprPkId
    });
    if (ret.status == this["$config"].apiStatus) {
      this.netSystemList = ret.data;
    }
  }
  async getOptionList(): Promise<void> {
    const data = await getOptionList([
      optionKey.orderStatusObj,
      optionKey.suppoertOrderObj,
      optionKey.chargingModeObj
    ]);
    this.orderStatusList = data[optionKey.orderStatusObj];
    this.abnormalTypeList = data[optionKey.suppoertOrderObj];
    // this.chargingModeList = data[optionKey.chargingModeObj];
  }

  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public exportChange(val: string[]) {
    this.formInline.colList = val;
  }
  public formDataNull(data: objAny): objAny {
    const json: objAny = {};
    for (const i in data) {
      if (data[i] !== "" && data[i] !== undefined) {
        json[i] = data[i];
      }
    }
    return json;
  }
  // public chargeTimesChange(val: string[]): void {
  //   this.formInline.startDate = val[0] || "";
  //   this.formInline.endDate = val[1] || "";
  // }
  // public payTimesChange(val: string[]): void {
  //   this.formInline.payStartTime = val[0] || "";
  //   this.formInline.payEndTime = val[1] || "";
  // }
  public chargeTimesChange(): void {
    this.getFormTime();
  }
  public getFormTime(): void {
    let startTime = "";
    let endTime = "";
    if (this.chargeTimes[0]) {
      startTime = this.$common.thisTimes(
        "yyyy-MM-dd",
        new Date(this.chargeTimes[0])
      );
      endTime = this.$common.thisTimes(
        "yyyy-MM-dd",
        new Date(this.chargeTimes[1])
      );
    }
    if (this.formInlineTimeType == 1) {
      this.formInline.startDate = startTime;
      this.formInline.endDate = endTime;
      this.formInline.payStartTime = "";
      this.formInline.payEndTime = "";
    } else {
      this.formInline.payStartTime = startTime;
      this.formInline.payEndTime = endTime;
      this.formInline.startDate = "";
      this.formInline.endDate = "";
    }
  }

  public timer = null;
  async getTableList(): Promise<void> {
    this.loading = true;

    const params = this.formDataNull(this.formInline);
    const ret = await getOrderPage(params);
    if (ret.status == this["$config"].apiStatus) {
      this.tableList = this["$common"].forTableList(ret.data);
      this.total = ret.total;
    }
    this.loading = false;

    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    // 自动刷新，开启新的定时器
    this.timer = setTimeout(() => {
      this.getTableList();
    }, 10000);
  }

  onSearch() {
    this.formInline.globalPageIndex = 1;
    if (this.formInline.areaPathList) {
      this.formInline.areaPath = this.formInline.areaPathList.join(",");
    }
    this.exportCondition = Object.assign({}, this.formInline);
    this.getTableList();
    this.$refs.orderStatistics?.getData();
  }

  public HandleDetail(item: objAny): void {
    this["$common"].save("charge-order-list-item", item); // 存在本地
    this["$router"].push("/oper-manage/charge-order-list/charge-order-detail");
  }

  public finishOrder(item: objAny) {
    const piEndOrder: objAny = this.$refs["piEndOrder"];
    piEndOrder.open(item);
    // const ret = await getChargeStop({ orderNo: item.orderNo });
    // if (ret.status === this.$config.apiStatus) {
    //   this.getTableList();
    // }
  }
  public handleAbnormal(item: objAny): void {
    this["$common"].save("charge-order-list-item", item); // 存在本地
    this["$router"].push("/oper-manage/charge-order-list/abnormal-order");
  }

  mounted() {
    this.$nextTick(() => {
      //如果路由有带电话参数，则取出来
      const query: objAny = this.$route.query || {};
      console.log(query);
      this.formInline.staPkId = query.staPkId || "";
      this.formInline.pilePkId = query.pilePkId || "";
      this.formInline.gunPkId = query.gunPkId || "";
      this.formInline.orderNo = query.orderNo || "";
      if (query.beginTime && query.endTime) {
        this.formInlineTimeType = 1;
        this.chargeTimes = [query.beginTime, query.endTime];
      } else if (JSON.stringify(query) == "{}") {
        const date = this.$common.thisTimes("yyyy-MM");
        const endTime = this.$common.thisTimes("yyyy-MM-dd");
        const startTime = date + "-01";
        this.chargeTimes = [startTime, endTime];
        this.formInline.startDate = startTime;
        this.formInline.endDate = endTime;
        this.formInlineTimeType = 1;
      } else if (JSON.stringify(query) !== "{}") {
        this.chargeTimes = [];
      }
      this.getTableList();
      this.getAllInterflow();
      this.getOptionList();
    });
  }
  activated() {
    this.getTableList();
  }
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
  deactivated() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}
